<template>
  <Tabs
    v-if="discount"
    :tab-name="['Detail', 'Bookings']"
    :tab-icon="['event_available', 'event']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <discountEdit
        :discount="discount"
        @discountUpdated="$emit('discountUpdated', $event)"
      />
    </template>
    <template slot="tab-pane-2">
      <discount-bookings :discount="discount" />
    </template>
  </Tabs>
</template>

<script>
import { Tabs } from "@/components";
import DiscountEdit from "./DiscountEdit";
import DiscountBookings from "./DiscountBookings";

export default {
  props: ["discount"],

  components: {
    Tabs,
    DiscountEdit,
    DiscountBookings
  },

  data() {
    return {};
  }
};
</script>
